const DataLayer = () => {

    const telecareBtnSubmit = document.querySelector('.single-product .summary.entry-summary #wd-add-to-cart');
    const allPackagesDataLayer = document.getElementsByClassName('packages-item-js');
    const plusInCart = document.querySelectorAll('.cart-content-wrapper .cart_item .quantity .plus, .cart-content-wrapper .cart_item .quantity .minus');

    function hasClass(elem, className) {
        return elem.className.split(' ').indexOf(className) > -1;
    }

    if(plusInCart) {
        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('plus')) {
                if(e.target.closest('.cart_item')) {
                    let plusParent = e.target.closest('.cart_item').querySelector('.product-remove a');
                    let parentName = '';
                    let parentPrice = '';
                    let parentCategory = '';
                    let parentQuantity = '';
                    let parentVariant = '';
                    let parentId = '';
        
                    if(plusParent.dataset.product_name) {
                        parentName = plusParent.dataset.product_name;
                    }
                    if(plusParent.dataset.product_price) {
                        parentPrice = plusParent.dataset.product_price;
                    }
                    if(plusParent.dataset.product_category) {
                        parentCategory = plusParent.dataset.product_category;
                    }
                    if(plusParent.dataset.product_quantity) {
                        parentQuantity = plusParent.dataset.product_quantity;
                    }
                    if(plusParent.dataset.product_id) {
                        parentId = plusParent.dataset.product_id;
                    }
        
                    //addToCartDataLayer(parentName,parentId,parentPrice,parentCategory,parentQuantity);
                } else if(e.target.closest('.mini_cart_item')) {
                    let plusParent = e.target.closest('.mini_cart_item').querySelector('.remove');
                    let parentName = '';
                    let parentPrice = '';
                    let parentCategory = '';
                    let parentQuantity = '';
                    let parentVariant = '';
                    let parentId = '';
        
                    if(plusParent.dataset.product_name) {
                        parentName = plusParent.dataset.product_name;
                    }
                    if(plusParent.dataset.product_price) {
                        parentPrice = plusParent.dataset.product_price;
                    }
                    if(plusParent.dataset.product_category) {
                        parentCategory = plusParent.dataset.product_category;
                    }
                    if(plusParent.dataset.product_quantity) {
                        parentQuantity = plusParent.dataset.product_quantity;
                    }
                    if(plusParent.dataset.product_id) {
                        parentId = plusParent.dataset.product_id;
                    }
        
                    //addToCartDataLayer(parentName,parentId,parentPrice,parentCategory,parentQuantity);
                }
            } else if (e.target.classList.contains('minus')) {
                if(e.target.closest('.cart_item')) {
                    let plusParent = e.target.closest('.cart_item').querySelector('.product-remove a');
                    let parentName = '';
                    let parentPrice = '';
                    let parentCategory = '';
                    let parentQuantity = '';
                    let parentVariant = '';
                    let parentId = '';
        
                    if(plusParent.dataset.product_name) {
                        parentName = plusParent.dataset.product_name;
                    }
                    if(plusParent.dataset.product_price) {
                        parentPrice = plusParent.dataset.product_price;
                    }
                    if(plusParent.dataset.product_category) {
                        parentCategory = plusParent.dataset.product_category;
                    }
                    if(plusParent.dataset.product_quantity) {
                        parentQuantity = plusParent.dataset.product_quantity;
                    }
                    if(plusParent.dataset.product_id) {
                        parentId = plusParent.dataset.product_id;
                    }
        
                    removeFromCartDataLayer(parentName,parentId,parentPrice,parentCategory,parentQuantity);
                } else if(e.target.closest('.mini_cart_item')) {
                    let plusParent = e.target.closest('.mini_cart_item').querySelector('.remove');
                    let parentName = '';
                    let parentPrice = '';
                    let parentCategory = '';
                    let parentQuantity = '';
                    let parentVariant = '';
                    let parentId = '';
        
                    if(plusParent.dataset.product_name) {
                        parentName = plusParent.dataset.product_name;
                    }
                    if(plusParent.dataset.product_price) {
                        parentPrice = plusParent.dataset.product_price;
                    }
                    if(plusParent.dataset.product_category) {
                        parentCategory = plusParent.dataset.product_category;
                    }
                    if(plusParent.dataset.product_quantity) {
                        parentQuantity = plusParent.dataset.product_quantity;
                    }
                    if(plusParent.dataset.product_id) {
                        parentId = plusParent.dataset.product_id;
                    }
        
                    removeFromCartDataLayer(parentName,parentId,parentPrice,parentCategory,parentQuantity);
                }
            }
        }, false);
    }

    if(allPackagesDataLayer) {
        for(var i = 0; i < allPackagesDataLayer.length; i++) {
            allPackagesDataLayer[i].addEventListener('click', function(el) {

                let packageType     = '';
                let packageName     = '';
                let packagePrice    = '';
                let packageId       = '';
                let FinalName       = '';
                let packageCategory = 'Subskrypcje';
                let packageQuantity = '1';

                const packageNameHtml = this.getElementsByClassName('packages-item__top-left-text')[0];
                const packagePriceText = this.getElementsByClassName('packages-item__price-total')[0];

                console.log(packageNameHtml.innerText.replace("\n", " "));

                if(this.parentNode.dataset.packagesType) {
                    packageType = this.parentNode.dataset.packagesType;
                }

                if(this.dataset.packagesId) {
                    packageId = this.dataset.packagesId;
                }

                if(packageNameHtml.innerText) {
                    packageName = packageNameHtml.innerText;
                }

                FinalName = packageType + ' - ' + packageName;

                if(packagePriceText) {
                    if(packagePriceText.innerText.includes('/')) {
                        let splitedText = packagePriceText.innerText.split('/');
                        packagePrice = splitedText[0].replace(" zł", "");
                    }
                }

                addToCartDataLayer(FinalName,packageId,packagePrice,packageCategory,packageQuantity);

            })
        }
    }


    if(telecareBtnSubmit) {
        telecareBtnSubmit.addEventListener('click', function(el) {
            const productInfo = document.getElementsByClassName('single-product-info-js')[0];
            const quantityInput = document.querySelector('.quantity input.qty');

            if(productInfo) {
                var productName = '';
                var productId = '';
                var productPrice = '';
                var productCategory = '';
                var productQuantity = 1;

                // Pobierz dane produktu, który został dodany do koszyka
                if(productInfo.dataset.productName) {
                    productName = productInfo.dataset.productName;
                }
                if(productInfo.dataset.productId) {
                    productId = productInfo.dataset.productId;
                }
                if(productInfo.dataset.productPrice) {
                    productPrice = productInfo.dataset.productPrice;
                }
                if(productInfo.dataset.productCategory) {
                    productCategory = productInfo.dataset.productCategory;
                }
                if(quantityInput) {
                    productQuantity = quantityInput.value;
                } else if(productInfo.dataset.productQuantity) {
                    productQuantity = productInfo.dataset.productQuantity;
                }
    
                addToCartDataLayer(productName,productId,productPrice,productCategory,productQuantity);
            }
        })
    }

    function addToCartDataLayer(name,id,price,category,quantity) {

        // Wywołaj zdarzenie "add_to_cart" w datalayer
        dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
            'currency': 'PLN',
            'items': [
                {
                'item_name': name,
                'item_id': id,
                'price': price,
                // 'brand': productBrand,
                'item_category': category,
                // 'variant': productVariant,
                'quantity': quantity
                }
            ]
        }
        });
    }

    function removeFromCartDataLayer(name,id,price,category,quantity) {

        // Wywołaj zdarzenie "add_to_cart" w datalayer
        dataLayer.push({
        'event': 'remove_from_cart',
        'ecommerce': {
            'currency': 'PLN',
            'items': [
                {
                'item_name': name,
                'item_id': id,
                'price': price,
                // 'brand': productBrand,
                'item_category': category,
                // 'variant': productVariant,
                'quantity': quantity
                }
            ]
        }
        });
    }
}

export default DataLayer;